import type { CellContext } from '@tanstack/react-table'
import { Archive, Edit, Trash2 } from 'lucide-react'

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  RowActionsMenu,
} from '@/components/ui'
import { useDialogActions } from '@/stores/dialog'
import type { Folder } from '../../stores/types'
import { DeleteFolderDialog } from '../dialogs/DeleteFolderDialog'
import { RenameFolderDialog } from '../dialogs/RenameFolderDialog'
import { archiveFolder } from './archiveFolder'

export const RowActionsCell = (cell: CellContext<Folder, unknown>) => {
  const { openDialog } = useDialogActions()
  const folder = cell.row.original

  return (
    <RowActionsMenu label="Folder actions">
      <DropdownMenuItem
        onClick={() => openDialog(RenameFolderDialog.id, folder)}
      >
        <Edit className="size-4" />
        Rename folder
      </DropdownMenuItem>
      {folder.kind === 'project' && (
        <DropdownMenuItem onClick={() => archiveFolder(folder)}>
          <Archive className="size-4" />
          Archive folder
        </DropdownMenuItem>
      )}
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => openDialog(DeleteFolderDialog.id, folder)}
        destructive
      >
        <Trash2 className="size-4" />
        Delete folder
      </DropdownMenuItem>
    </RowActionsMenu>
  )
}
